import { render, staticRenderFns } from "./reportForms.vue?vue&type=template&id=6db50dbc&"
import script from "./reportForms.vue?vue&type=script&lang=js&"
export * from "./reportForms.vue?vue&type=script&lang=js&"
import style0 from "./reportForms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "reportForms.vue"
export default component.exports